import React, { useEffect, useState } from 'react'
import FerryServiceForm from './FerryServiceForm'
import { useTranslation } from 'react-i18next'
import { INITIAL_VALUES, toFerryValues, toRequestParams } from './form'
import { fetchFerryService, updateFerryService } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useNavigatePrevent } from 'context/navigatePrevent'

export function FerryServiceEditForm (props) {
  const ferryServiceId = props.match.params.id

  const [initialValues, setInitialValues] = useState(INITIAL_VALUES)
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const { handleError } = useErrorHandling()
  const { t } = useTranslation()
  const { setNavigationUnlocked } = useNavigatePrevent()

  useEffect(() => {
      setLoading(true)
      fetchFerryService(ferryServiceId)
        .then(ferryService => {
          const formValues = toFerryValues(ferryService)
          setInitialValues(formValues)
        })
        .catch(error => handleError(error))
        .then(() => setLoading(false))
    }, [ferryServiceId, handleError]
  )

  const handleSubmit = (values, onSuccess) => {
    setLoading(true)
    updateFerryService(ferryServiceId, toRequestParams(values))
      .then(() => onSuccess(ferryServiceId)
        .then(() => setSuccessDialogOpen(true))
        .catch(handleError)
      )
      .catch(error => handleError(error))
      .then(() => setLoading(false))
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    setNavigationUnlocked(history => history.push('/ferry-services'))
  }

  return (
    <>
      <SuccessDialog
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
        content="ferryServices.form.editForm.successDialog.content"/>
      <FerryServiceForm
        title={t('ferryServices.form.editForm.title')}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        loading={loading}
        entityId={ferryServiceId}
      />
    </>
  )
}
